import { Avatar, Divider, Grid, Typography } from "@mui/material";
import { getInitials } from "../../../common/helpers/getInitials";

type Props = {
  fullName: string;
  username: string;
};

const UserInfo = ({ fullName, username }: Props) => (
  <>
    <Grid container p={2}>
      <Grid item xs={2} alignSelf="center">
        <Avatar sx={{ bgcolor: "primary.main" }}>
          {getInitials(fullName)}
        </Avatar>
      </Grid>
      <Grid item xs={10}>
        <Typography variant="header" fontWeight="600">
          {fullName}
        </Typography>
        <Typography variant="secondary">{username}</Typography>
      </Grid>
    </Grid>
    <Divider
      sx={{
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        width: "100%",
        marginBottom: "8px",
      }}
    />
  </>
);

export default UserInfo;
